import { Controller } from '@hotwired/stimulus'
import { put } from '@rails/request.js'

export default class extends Controller {
  static targets = ["menu", "title"]
  static values = {
    updateUrl: String,
  }

  abortController = undefined

  statusKey = ""
  statusSettings = {}

  connect(){
    this.statusKey = this.element.dataset.statusKey
    this.statusSettings = JSON.parse(this.element.dataset.statusSettings)

    this.setStatusStyle(this.statusKey)
  }

  setStatusStyle(statusKey){
    if (this.statusSettings[statusKey]){
      const settings = this.statusSettings[statusKey]

      this.element.style.setProperty('--media-status-toggle-text-color', settings?.light?.text)
      this.element.style.setProperty('--media-status-toggle-dark-text-color', settings?.dark?.text)
    }
  }

  setStatusTitle(statusKey){
    if (this.statusSettings[statusKey]){
      const settings = this.statusSettings[statusKey]

      this.titleTarget.innerText = settings?.title
    }
  }

  async saveChanges(statusKey){
    if (this.updateUrlValue){
      await put(this.updateUrlValue, {
        contentType: 'application/json',
        body: JSON.stringify({
          media_file: {
            media_status: statusKey,
          },
        }),
        responseKind: 'json',
      })
    }
  }

  async selectStatus(e){
    const { target: { dataset: { mediaStatusKey } } } = e

    this.statusKey = mediaStatusKey
    this.setStatusStyle(mediaStatusKey)
    this.setStatusTitle(mediaStatusKey)

    await this.saveChanges(mediaStatusKey)
  }

  resetOrStartAbortController(){
    if(this.abortController){
      delete this.abortController;
    }

    this.abortController = new AbortController();
  }

  toggleMenu() {
    if (this.menuTarget.classList.contains('hidden')){
      this.resetOrStartAbortController()

      document.addEventListener(
        'click',
        (e) => {
          if (!this.element.contains(e.target)){
            this.toggleMenu();
          }
        },
        {
          signal: this.abortController.signal,
        },
      );
      this.menuTarget.classList.replace('hidden', 'visible');
    } else {
      this.abortController.abort('Clicked Outside');
      this.menuTarget.classList.replace('visible', 'hidden');
    }
  }
}
